import NftCollectionMetadata from '../types/nft-collection-metadata.ts';

function nftRewardCollectionMetadataMapped(data: any): NftCollectionMetadata {
  return {
    name: data?.nft_collection_name ?? null,
    imagePreview: data?.nft_collection_preview_100x100 ?? null,
  };
}

export default nftRewardCollectionMetadataMapped;
